/**
 * Application configuration file
 *
 * This file contains static configuration (e.g. API Base URL, debug mode), that will be updated
 * by deploy system while going to production
 *
 * @author Fabio Dal Santo <fabio@gestionaleauto.com>
 */

export default Object.freeze({
  /**
   * State if the application is in debug mode.
   * It activates, for example, Redux Dev Tools
   */
  debug: process.env.NODE_ENV !== 'production',
  /**
   * Name of cookie where external quote data are stored
   */
  quoteCookie: window.ecommerceData ? window.ecommerceData.cookieName : 'prequote',
  /**
   * Name of cookie that keeps current language value
   */
  langCookie: 'qtrans_front_language',
  /**
   * API Base URL used to interact with backend
   */
  // apiBaseUrl: 'https://ec-api-gl.gestionaleauto.com',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:50000',
  // apiBaseUrl: 'http://localhost:50000',
  /**
   * PGP API Base URL used to handle quote data
   */
  // pgpApiBaseUrl: 'https://ec-api-gl.gestionaleauto.com',
  pgpApiBaseUrl: process.env.REACT_APP_PGP_API_BASE_URL || 'https://ec-api.gestionaleauto.com',
  // pgpApiBaseUrl: 'http://localhost:50000',
});
